import { ca } from '@cian/analytics';

import { TJsonQuery } from '../../../../packages/JsonQuery';

export const trackRetryButtonClick = (sc: TJsonQuery) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'BrokerDeal',
    action: 'click',
    label: 'BrokerDealPopUpRetry',
    sc,
    page: {
      pageType: 'Listing',
      siteType: 'desktop',
    },
    useLastProducts: true,
  });
};
